var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Estado UF","placeholder":"Estado","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.estadoComponente),callback:function ($$v) {_vm.estadoComponente=$$v},expression:"estadoComponente"}})}
var staticRenderFns = []

export { render, staticRenderFns }